import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

const articles = [
  {
    id: 7,
    categorie: 'Vie du Barreau',
    categorieColor: 'bg-stone-100 text-stone-700',
    titre: 'Grève des avocats — Justice Morte : le Barreau de Paris se mobilise',
    date: '13 avril 2026',
    auteur: 'Maître Joël Gautier',
    extrait: 'Ce jour, les avocats du Barreau de Paris et de toute la France ont décidé de cesser toute activité judiciaire en signe de protestation. Renvois d\'audiences, palais de justice déserts, robes noires dans la rue : la profession crie son désarroi face à une justice exsangue, sous-financée et à bout de souffle. Maître Joël Gautier se joint à ce mouvement et exprime sa solidarité totale avec ses confrères.',
    image: 'https://public.readdy.ai/ai/img_res/bb9fe23b0537b445aeb32cb75fb000a1.jpg',
    tempsLecture: '3 min',
  },
  {
    id: 1,
    categorie: 'Droit Pénal',
    categorieColor: 'bg-red-100 text-red-700',
    titre: 'Réforme du Code Pénal 2025 : Ce qui change pour les justiciables',
    date: '12 juin 2025',
    auteur: 'Maître Joël Gautier',
    extrait: 'La réforme du code pénal entrée en vigueur en janvier 2025 introduit des modifications substantielles concernant les peines alternatives à l\'incarcération et le renforcement des droits de la défense. Découvrez les points clés à retenir.',
    image: 'https://readdy.ai/api/search-image?query=French%20courtroom%20interior%20with%20elegant%20wooden%20benches%20and%20formal%20legal%20setting%20featuring%20warm%20golden%20lighting%20marble%20columns%20and%20classic%20French%20judicial%20architecture%20representing%20criminal%20law%20reform%20and%20justice%20system%20modernization&width=800&height=500&seq=actu-penal-1&orientation=landscape',
    tempsLecture: '5 min',
  },
  {
    id: 2,
    categorie: 'Droit des Affaires',
    categorieColor: 'bg-amber-100 text-amber-700',
    titre: 'Nouvelles obligations de conformité pour les PME en 2025',
    date: '3 juin 2025',
    auteur: 'Maître Joël Gautier',
    extrait: 'Les petites et moyennes entreprises font face à de nouvelles exigences réglementaires en matière de conformité. Entre RGPD renforcé, obligations ESG et nouvelles règles comptables, voici un tour d\'horizon complet des changements à anticiper.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20French%20business%20office%20with%20elegant%20minimalist%20design%20featuring%20professional%20executives%20reviewing%20legal%20compliance%20documents%20on%20premium%20wooden%20desk%20with%20soft%20natural%20lighting%20and%20sophisticated%20gold%20accents%20representing%20corporate%20law&width=800&height=500&seq=actu-affaires-2&orientation=landscape',
    tempsLecture: '7 min',
  },
  {
    id: 3,
    categorie: 'Droit de la Famille',
    categorieColor: 'bg-green-100 text-green-700',
    titre: 'Divorce par consentement mutuel : simplifications procédurales',
    date: '28 mai 2025',
    auteur: 'Maître Joël Gautier',
    extrait: 'La procédure de divorce par consentement mutuel a été allégée par une circulaire ministérielle récente. Les délais sont raccourcis et les formalités simplifiées pour les couples souhaitant se séparer à l\'amiable. Analyse détaillée des nouvelles modalités.',
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20elegant%20French%20notary%20office%20with%20warm%20lighting%20and%20refined%20wooden%20furniture%20representing%20family%20law%20mediation%20and%20amicable%20divorce%20proceedings%20with%20tasteful%20decor%20and%20professional%20atmosphere%20conveying%20calm%20resolution&width=800&height=500&seq=actu-famille-3&orientation=landscape',
    tempsLecture: '4 min',
  },
  {
    id: 4,
    categorie: 'Droit des Contrats',
    categorieColor: 'bg-teal-100 text-teal-700',
    titre: 'Force majeure et imprévision : jurisprudence récente de la Cour de Cassation',
    date: '20 mai 2025',
    auteur: 'Maître Joël Gautier',
    extrait: 'La Cour de Cassation a rendu plusieurs arrêts importants précisant les contours de la force majeure et de la théorie de l\'imprévision dans les contrats commerciaux. Ces décisions ont des implications majeures pour la rédaction et l\'exécution des contrats.',
    image: 'https://readdy.ai/api/search-image?query=Prestigious%20French%20law%20library%20with%20floor%20to%20ceiling%20bookshelves%20filled%20with%20legal%20volumes%20and%20elegant%20reading%20tables%20with%20brass%20lamps%20representing%20contract%20law%20jurisprudence%20and%20Cour%20de%20Cassation%20decisions%20in%20sophisticated%20academic%20setting&width=800&height=500&seq=actu-contrats-4&orientation=landscape',
    tempsLecture: '6 min',
  },
  {
    id: 5,
    categorie: 'Droit Pénal',
    categorieColor: 'bg-red-100 text-red-700',
    titre: 'Cybercriminalité : nouvelles infractions et sanctions renforcées',
    date: '14 mai 2025',
    auteur: 'Maître Joël Gautier',
    extrait: 'Face à l\'explosion des cyberattaques et escroqueries en ligne, le législateur a considérablement durci l\'arsenal répressif. Nouvelles qualifications pénales, peines alourdies et coopération internationale renforcée : ce que tout professionnel doit savoir.',
    image: 'https://readdy.ai/api/search-image?query=Sophisticated%20dark%20legal%20office%20with%20modern%20technology%20screens%20displaying%20cybersecurity%20data%20and%20digital%20forensics%20representing%20cybercrime%20law%20enforcement%20with%20elegant%20professional%20atmosphere%20and%20subtle%20gold%20lighting%20accents&width=800&height=500&seq=actu-cyber-5&orientation=landscape',
    tempsLecture: '8 min',
  },
  {
    id: 6,
    categorie: 'Droit des Affaires',
    categorieColor: 'bg-amber-100 text-amber-700',
    titre: 'Restructuration d\'entreprise : guide pratique des procédures collectives',
    date: '5 mai 2025',
    auteur: 'Maître Joël Gautier',
    extrait: 'Sauvegarde, redressement judiciaire, liquidation : les procédures collectives sont souvent mal comprises des dirigeants. Ce guide pratique explique les différentes options disponibles, leurs conditions d\'ouverture et les stratégies à adopter pour protéger au mieux les intérêts de l\'entreprise.',
    image: 'https://readdy.ai/api/search-image?query=Executive%20French%20boardroom%20with%20panoramic%20city%20view%20featuring%20elegant%20conference%20table%20and%20professional%20legal%20advisors%20reviewing%20restructuring%20documents%20with%20sophisticated%20minimalist%20design%20warm%20lighting%20and%20premium%20furnishings&width=800&height=500&seq=actu-restructuration-6&orientation=landscape',
    tempsLecture: '9 min',
  },
];

const categories = ['Tous', 'Vie du Barreau', 'Droit Pénal', 'Droit des Affaires', 'Droit de la Famille', 'Droit des Contrats'];

export default function ActualitesPage() {
  const [scrolled, setScrolled] = useState(false);
  const [activeCategorie, setActiveCategorie] = useState('Tous');
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'Blog',
      name: 'Actualités Juridiques — Cabinet Joël Gautier',
      description: 'Analyses, commentaires et décryptages juridiques par Maître Joël Gautier, avocat au Barreau de Paris.',
      url: `${siteUrl}/actualites`,
      inLanguage: 'fr-FR',
      publisher: {
        '@type': 'LegalService',
        name: 'Cabinet Joël Gautier',
        url: siteUrl,
      },
      blogPost: articles.map((a) => ({
        '@type': 'BlogPosting',
        headline: a.titre,
        description: a.extrait,
        author: { '@type': 'Person', name: a.auteur },
        datePublished: a.date,
        image: a.image,
        url: `${siteUrl}/actualites`,
        keywords: a.categorie,
      })),
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-actualites';
    script.textContent = JSON.stringify(schema);
    const existing = document.getElementById('schema-actualites');
    if (existing) existing.remove();
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById('schema-actualites');
      if (el) el.remove();
    };
  }, []);

  const goToContact = () => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('contact');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  const articlesFiltres = activeCategorie === 'Tous'
    ? articles
    : articles.filter((a) => a.categorie === activeCategorie);

  const articleVedette = articles[0];
  const autresArticles = articlesFiltres.filter((a) => a.id !== articleVedette.id || activeCategorie !== 'Tous');

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-white shadow-sm'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src="https://static.readdy.ai/image/2457a24757fcc37e63ebfd614e72adca/b1558608be687494406c07fd3a70dac7.jpeg" alt="Maître Joël Gautier" className="h-28 w-auto" />
          </Link>
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-sm font-medium text-gray-900 hover:text-[#C9A961] transition-colors">Accueil</Link>
            <Link to="/tarifs" className="text-sm font-medium text-gray-900 hover:text-[#C9A961] transition-colors">Tarifs</Link>
            <Link to="/a-propos" className="text-sm font-medium text-gray-900 hover:text-[#C9A961] transition-colors">À propos</Link>
            <Link to="/actualites" className="text-sm font-medium text-[#C9A961] transition-colors">Actualités</Link>
            <button onClick={goToContact} className="text-sm font-medium text-gray-900 hover:text-[#C9A961] transition-colors cursor-pointer bg-transparent border-none">Contact</button>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <span className="text-xs font-semibold tracking-widest text-[#C9A961] uppercase mb-4 block">Cabinet Joël Gautier</span>
          <h1 className="text-6xl font-bold text-[#1A2B4A] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Actualités Juridiques
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Restez informé des dernières évolutions du droit. Analyses, commentaires et décryptages par Maître Joël Gautier.
          </p>
        </div>
      </section>

      {/* Article vedette */}
      {activeCategorie === 'Tous' && (
        <section className="py-12 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl group cursor-pointer">
              <div className="w-full h-[520px]">
                <img
                  src={articleVedette.image}
                  alt={articleVedette.titre}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F1B2E]/95 via-[#0F1B2E]/50 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-12">
                <div className="flex items-center gap-4 mb-4">
                  <span className="px-3 py-1 bg-[#C9A961] text-white text-xs font-semibold rounded-full uppercase tracking-wide">
                    À la une
                  </span>
                  <span className={`px-3 py-1 text-xs font-semibold rounded-full ${articleVedette.categorieColor}`}>
                    {articleVedette.categorie}
                  </span>
                </div>
                <h2 className="text-4xl font-bold text-white mb-4 max-w-3xl leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {articleVedette.titre}
                </h2>
                <p className="text-white/80 text-lg max-w-2xl mb-6 leading-relaxed">
                  {articleVedette.extrait}
                </p>
                <div className="flex items-center gap-6 text-white/70 text-sm">
                  <span className="flex items-center gap-2">
                    <i className="ri-user-line"></i>
                    {articleVedette.auteur}
                  </span>
                  <span className="flex items-center gap-2">
                    <i className="ri-calendar-line"></i>
                    {articleVedette.date}
                  </span>
                  <span className="flex items-center gap-2">
                    <i className="ri-time-line"></i>
                    {articleVedette.tempsLecture} de lecture
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Filtres catégories */}
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategorie(cat)}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap border ${
                  activeCategorie === cat
                    ? 'bg-[#1A2B4A] text-white border-[#1A2B4A]'
                    : 'bg-white text-gray-700 border-gray-300 hover:border-[#C9A961] hover:text-[#C9A961]'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Grille d'articles */}
      <section className="pb-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          {activeCategorie !== 'Tous' && articlesFiltres.length === 0 ? (
            <div className="text-center py-20 text-gray-500 text-lg">Aucun article dans cette catégorie pour le moment.</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {(activeCategorie === 'Tous' ? articles.slice(1) : articlesFiltres).map((article) => (
                <article
                  key={article.id}
                  className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer border border-gray-100"
                >
                  <div className="w-full h-56 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.titre}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-7">
                    <div className="flex items-center gap-3 mb-4">
                      <span className={`px-3 py-1 text-xs font-semibold rounded-full ${article.categorieColor}`}>
                        {article.categorie}
                      </span>
                      <span className="text-xs text-gray-400 flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {article.tempsLecture}
                      </span>
                    </div>
                    <h3 className="text-xl font-bold text-[#1A2B4A] mb-3 leading-snug group-hover:text-[#C9A961] transition-colors" style={{ fontFamily: 'Playfair Display, serif' }}>
                      {article.titre}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed mb-5 line-clamp-3">
                      {article.extrait}
                    </p>
                    <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                      <div className="flex items-center gap-2 text-xs text-gray-500">
                        <i className="ri-calendar-line"></i>
                        <span>{article.date}</span>
                      </div>
                      <span className="text-xs font-semibold text-[#C9A961] flex items-center gap-1 group-hover:gap-2 transition-all">
                        Lire la suite <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA Newsletter / Contact */}
      <section className="py-20 bg-gradient-to-br from-[#1A2B4A] to-[#2A3B5A]">
        <div className="max-w-4xl mx-auto px-6 text-center text-white">
          <i className="ri-scales-line text-[#C9A961] text-5xl mb-6 block"></i>
          <h2 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Une question juridique ?
          </h2>
          <p className="text-white/80 text-lg mb-10 max-w-xl mx-auto">
            Maître Joël Gautier et son équipe sont à votre disposition pour analyser votre situation et vous conseiller.
          </p>
          <button
            onClick={goToContact}
            className="inline-flex items-center gap-4 px-8 py-4 bg-white text-[#1A2B4A] rounded-full font-medium shadow-lg hover:shadow-xl transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            Prendre Rendez-vous
            <span className="w-10 h-10 bg-[#C9A961] rounded-full flex items-center justify-center">
              <i className="ri-calendar-line text-white"></i>
            </span>
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0F1B2E] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.08]">
          <i className="ri-scales-line text-[#C9A961] text-[400px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></i>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12">
            <div className="lg:col-span-4">
              <img src="https://static.readdy.ai/image/2457a24757fcc37e63ebfd614e72adca/b1558608be687494406c07fd3a70dac7.jpeg" alt="Maître Joël Gautier" className="h-20 mb-6" />
              <h3 className="text-4xl font-light mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
                Justice, Intégrité<br />
                &amp; Excellence
              </h3>
            </div>
            <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
              <div>
                <h4 className="text-base font-bold mb-4">Nos Services</h4>
                <ul className="space-y-2">
                  <li><a href="#" className="text-sm text-white/70 hover:text-[#C9A961] transition-colors cursor-pointer">Droit des Affaires</a></li>
                  <li><a href="#" className="text-sm text-white/70 hover:text-[#C9A961] transition-colors cursor-pointer">Droit Famille</a></li>
                  <li><a href="#" className="text-sm text-white/70 hover:text-[#C9A961] transition-colors cursor-pointer">Droit Pénal</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-base font-bold mb-4">Le Cabinet</h4>
                <ul className="space-y-2">
                  <li><Link to="/a-propos" className="text-sm text-white/70 hover:text-[#C9A961] transition-colors cursor-pointer">À Propos</Link></li>
                  <li><a href="#" className="text-sm text-white/70 hover:text-[#C9A961] transition-colors cursor-pointer">Équipe</a></li>
                  <li><Link to="/actualites" className="text-sm text-white/70 hover:text-[#C9A961] transition-colors cursor-pointer">Actualités</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="text-base font-bold mb-4">Ressources</h4>
                <ul className="space-y-2">
                  <li><a href="#" className="text-sm text-white/70 hover:text-[#C9A961] transition-colors cursor-pointer">FAQ</a></li>
                  <li><a href="#" className="text-sm text-white/70 hover:text-[#C9A961] transition-colors cursor-pointer">Guides Juridiques</a></li>
                  <li><Link to="/actualites" className="text-sm text-white/70 hover:text-[#C9A961] transition-colors cursor-pointer">Blog</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="text-base font-bold mb-4">Contact</h4>
                <ul className="space-y-2">
                  <li><button onClick={goToContact} className="text-sm text-white/70 hover:text-[#C9A961] transition-colors cursor-pointer bg-transparent border-none">Prendre RDV</button></li>
                  <li><button onClick={goToContact} className="text-sm text-white/70 hover:text-[#C9A961] transition-colors cursor-pointer bg-transparent border-none">Nous Écrire</button></li>
                  <li><button onClick={goToContact} className="text-sm text-white/70 hover:text-[#C9A961] transition-colors cursor-pointer bg-transparent border-none">Urgences</button></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="border-t border-[#C9A961]/20 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-6">
              <p className="text-sm text-white/70">© 2025 Cabinet Joël Gautier. Tous droits réservés.</p>
              <div className="flex gap-5">
                <a href="#" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-[#C9A961] hover:bg-[#C9A961]/10 transition-all cursor-pointer">
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-[#C9A961] hover:bg-[#C9A961]/10 transition-all cursor-pointer">
                  <i className="ri-twitter-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-[#C9A961] hover:bg-[#C9A961]/10 transition-all cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-[#C9A961] hover:bg-[#C9A961]/10 transition-all cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
              </div>
              <div className="flex gap-4 text-sm text-white/70">
                <a href="#" className="hover:text-[#C9A961] transition-colors cursor-pointer">Mentions Légales</a>
                <span>|</span>
                <a href="#" className="hover:text-[#C9A961] transition-colors cursor-pointer">Confidentialité</a>
                <span>|</span>
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A961] transition-colors cursor-pointer">Powered by Readdy</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
